module.exports = __webpack_public_path__ + "img/arrow-down.a615132c.svg";